module.exports = __webpack_public_path__ + "static/logopatterns-888bca6c5e241acfee67896946b1cbea.png";